import { useLocation } from 'react-router-dom'
import Editor from './index'
import { QRCodeModal } from '../AI/AIChatAssistant/QRCodeModal'
import AIChatAssistant from '../AI/AIChatAssistant/CollectionsChatAssistant'

interface EditorWithAIProps {
  match: {
    params: {
      appId: string
    }
  }
}

export const EditorWithAI = ({ match }: EditorWithAIProps): JSX.Element => {
  const { appId } = match.params
  const location = useLocation()

  return (
    <div className="editor-with-ai-container">
      <div className="editor-container">
        <Editor match={match} location={location} />
      </div>
      <div className="ai-container">
        <AIChatAssistant appId={appId} />
        <QRCodeModal appId={appId} />
      </div>
    </div>
  )
}
